// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isSameQuarter/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isSameQuarter = convertToFP(fn, 2);
export default isSameQuarter;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isSameQuarter/index.js
// module id = 935
// module chunks = 0